import { useRouter } from '@atlassian/jira-router';

export const useIsEmbed = () => {
	const [
		{
			location: { pathname },
		},
	] = useRouter();

	if (pathname.endsWith('/embed')) {
		return true;
	}
	return false;
};
